import React from 'react';

import airplane2_starting from "../../../assets/images/icons/airplane2_starting.svg";
import arrow_circle from "../../../assets/images/icons/arrow_circle.svg";
import arrow_cross from "../../../assets/images/icons/arrow_cross.svg";
import bird from "../../../assets/images/icons/bird.svg";
import brush from "../../../assets/images/icons/brush.svg";
import calculator from "../../../assets/images/icons/calculator.svg";
import cloud_download from "../../../assets/images/icons/cloud_download.svg";
import cloud_upload from "../../../assets/images/icons/cloud_upload.svg";
import document_gear from "../../../assets/images/icons/document_gear.svg";
import earth2 from "../../../assets/images/icons/earth2.svg";
import extend from "../../../assets/images/icons/extend.svg";
import fillet from "../../../assets/images/icons/fillet.svg";
import gearwheels from "../../../assets/images/icons/gearwheels.svg";
import graphic_tool from "../../../assets/images/icons/graphic_tool.svg";
import hand_spread from "../../../assets/images/icons/hand_spread.svg";
import houses from "../../../assets/images/icons/houses.svg";
import iconFile from "../../../assets/images/icons/document_text.svg";
import install from "../../../assets/images/icons/install.svg";
import item_tool from "../../../assets/images/icons/item_tool.svg";
import laptop from "../../../assets/images/icons/laptop.svg";
import layout from "../../../assets/images/icons/layout.svg";
import lifebelt from "../../../assets/images/icons/lifebelt.svg";
import lightbulb_on from "../../../assets/images/icons/lightbulb_on.svg";
import logo_circle from "../../../assets/images/icons/logo_circle.png";
import logo_stamp from "../../../assets/images/icons/logo_stamp.png";
import mobile_crane from "../../../assets/images/icons/mobile_crane.svg";
import mouse_pointer from "../../../assets/images/icons/mouse_pointer.svg";
import nav_up from "../../../assets/images/icons/nav_up.svg";
import offset from "../../../assets/images/icons/offset.svg";
import orbit_tool from "../../../assets/images/icons/orbit_tool.svg";
import precision_square from "../../../assets/images/icons/precision_square.svg";
import route_tool from "../../../assets/images/icons/route_tool.svg";
import set_zero_point from "../../../assets/images/icons/set_zero_point.svg";
import shade_blocks from "../../../assets/images/icons/shade_blocks.svg";
import shade_routes from "../../../assets/images/icons/shade_routes.svg";
import sign_warning from "../../../assets/images/icons/sign_warning.svg";
import subdivision_tool from "../../../assets/images/icons/subdivision_tool.svg";
import tape_measure from "../../../assets/images/icons/tape_measure.svg";
import teacher from "../../../assets/images/icons/teacher.svg";
import tree_tool from "../../../assets/images/icons/tree_tool.svg";
import uianalysispanels from "../../../assets/images/icons/uianalysispanels.png";
import uicitydesignassistant from "../../../assets/images/icons/uicitydesignassistant.png";
import uimaindisplaywindow from "../../../assets/images/icons/uimaindisplaywindow.png";
import uiproperties from "../../../assets/images/icons/uiproperties.png";
import uiribbon from "../../../assets/images/icons/uiribbon.png";
import uistatus from "../../../assets/images/icons/uistatus.png";
import users5 from "../../../assets/images/icons/users5.svg";
import window from "../../../assets/images/icons/window.svg";

let icons = {
  airplane2_starting: airplane2_starting,
  arrow_circle: arrow_circle,
  arrow_cross: arrow_cross,
  bird: bird,
  brush: brush,
  calculator: calculator,
  cloud_download: cloud_download,
  cloud_upload: cloud_upload,
  default: iconFile,
  document_gear: document_gear,
  earth2: earth2,
  extend: extend,
  fillet: fillet,
  gearwheels: gearwheels,
  graphic_tool: graphic_tool,
  hand_spread: hand_spread,
  houses: houses,
  install: install,
  item_tool: item_tool,
  laptop: laptop,
  layout: layout,
  lifebelt: lifebelt,
  lightbulb_on: lightbulb_on,
  logo_circle: logo_circle,
  logo_stamp: logo_stamp,
  mobile_crane: mobile_crane,
  mouse_pointer: mouse_pointer,
  nav_up: nav_up,
  offset: offset,
  orbit_tool: orbit_tool,
  precision_square: precision_square,
  route_tool: route_tool,
  set_zero_point: set_zero_point,
  shade_blocks: shade_blocks,
  shade_routes: shade_routes,
  sign_warning: sign_warning,
  subdivision_tool: subdivision_tool,
  tape_measure: tape_measure,
  teacher: teacher,
  tree_tool: tree_tool,
  uianalysispanels: uianalysispanels,
  uicitydesignassistant: uicitydesignassistant,
  uimaindisplaywindow: uimaindisplaywindow,
  uiproperties: uiproperties,
  uiribbon: uiribbon,
  uistatus: uistatus,
  users5: users5,
  window: window
};

const HelpArticleIcon = props => {
  let selectedIcon = props.reference ? icons[props.reference] : icons.default;
  return (
    <img src={selectedIcon} alt={props.title} title={props.title} style={{width: "100%"}} />
  );
};

export default HelpArticleIcon;
